<template>
    <q-btn v-if="!activateOnly && (props.row['canActivate'] || props.row['canRenew'] || props.row['canUpgradeMJ8'] || props.row['canUpgradePro'])"
           style="min-width: 108px;"
           size="sm" color="primary" outline icon="mdi-plus" label="Actions">
        <q-menu anchor="bottom right" self="top right" auto-close :fit="fit">

            <q-list dense class="text-caption" style="min-width: 210px;" separator dark>

                <q-item v-if="showActivateOption"
                        clickable class="bg-primary text-white"
                        @click="activateLicense(props.row)">
                    <q-item-section avatar style="min-width: 0px">
                        <q-icon size="xs" name="mdi-lock-open-variant-outline" />
                    </q-item-section>

                    <q-item-section>Activate</q-item-section>
                </q-item>
                <q-item v-if="showRenewOption"
                        :clickable="!props.row['disableRenew']"
                        class="bg-primary text-white"
                        :disabled="props.row['disableRenew']"
                        @click="addRenewItem(props.row)">
                    <q-item-section avatar style="min-width: 0px">
                        <q-icon size="xs" name="mdi-refresh" />
                    </q-item-section>

                    <q-item-section>Renew</q-item-section>

                    <q-tooltip v-if="props.row['disableRenew']" anchor="center right" self="center left" :offset="[10, 10]">
                        License is Already in Cart
                    </q-tooltip>
                </q-item>
                <q-item v-if="showUpgradeToMJ8Option"
                        :clickable="!props.row['disableUpgrade']"
                        class="bg-primary text-white"
                        :disabled="props.row['disableUpgrade']"
                        @click="addUpgradeItem(props.row, 'MJ8')">
                    <q-item-section avatar style="min-width: 0px">
                        <q-icon size="xs" name="mdi-arrow-up-bold-hexagon-outline" />
                    </q-item-section>

                    <q-item-section>Upgrade to MJ8 License</q-item-section>

                    <q-tooltip v-if="props.row['disableUpgrade']" anchor="center right" self="center left" :offset="[10, 10]">
                        License is Already in Cart
                    </q-tooltip>
                </q-item>
                <q-item v-if="showUpgradeToProOption"
                        :clickable="!props.row['disableUpgrade']"
                        class="bg-primary text-white"
                        :disabled="props.row['disableUpgrade']"
                        @click="addUpgradeItem(props.row, 'PF')">
                    <q-item-section avatar style="min-width: 0px">
                        <q-icon size="xs" name="mdi-arrow-up-bold-hexagon-outline" />
                    </q-item-section>

                    <q-item-section>Upgrade to Pro License</q-item-section>

                    <q-tooltip v-if="props.row['disableUpgrade']" anchor="center right" self="center left" :offset="[10, 10]">
                        License is Already in Cart
                    </q-tooltip>
                </q-item>

            </q-list>
        </q-menu>
    </q-btn>
</template>
<script>
    export default {
        name: 'btn-license-action-menu',
        props: {
            fit: Boolean,
            activateOnly: Boolean,
            props: Object,
            getProductsForPurchaseData: Array,
        },
        data() {
            return {
                showActivateOption: Boolean,
                showRenewOption: Boolean,
                showUpgradeToMJ8Option: Boolean,
                showUpgradeToProOption: Boolean,
            }
        },
        methods: {
            addRenewItem(item) {
                if (!item) return

                let product = this.subscriptionRenewalProducts?.find(p => p.productCategoryID == item.productCategory && p.edition == item.productEdition)

                const payload = {
                    product: product,
                    currency: this.cart.currency,
                    licenses: [item],
                }
                this.$store.dispatch('syncRenewUpgradeItems', payload)
                this.disabledRenewUpgradeOptions(item)
            },
            addUpgradeItem(item, upgradeToEdition) {
                if (!item) return

                let product = this.upgradeProducts?.find(p => p.productCategoryID == item.productCategory && p.edition == item.productEdition && p.id.includes(upgradeToEdition))
                const payload = {
                    product: product,
                    currency: this.cart.currency,
                    licenses: [item],
                }
                this.$store.dispatch('syncRenewUpgradeItems', payload)
                this.disabledRenewUpgradeOptions(item)
            },
            activateLicense(license) {
                this.$emit('activate', license)
            },
            disabledRenewUpgradeOptions(item) {
                item.disableRenew = true
                item.disableUpgrade = true
            },
            isLicenseInCart() {
                var license = this.props.row
                if (this.cart.cartItems && this.cart.cartItems.some(i => i.licenseID === license.id)) {
                    this.disabledRenewUpgradeOptions(license)
                }
            },
            setOptionVisibilityVariables() {
                var license = this.props.row

                this.showActivateOption = license.canActivate && license.activeAssignment && license.activeAssignment.customerID
                this.showRenewOption = license.canRenew && license.managerCustomerID == this.user.id
                this.showUpgradeToMJ8Option = license.canUpgradeMJ8 && license.managerCustomerID == this.user.id
                this.showUpgradeToProOption = license.canUpgradePro && license.managerCustomerID == this.user.id
            }
        },
        computed: {
            user() { return this.$store.getters.authUser },
            cart() { return this.$store.getters.cart },
            subscriptionRenewalProducts() {
                if (this.getProductsForPurchaseData)
                    return this.getProductsForPurchaseData?.filter(p => p.isSubscription == true && p.visible == true)
                return []
            },
            upgradeProducts() {
                if (this.getProductsForPurchaseData)
                    return this.getProductsForPurchaseData?.filter(p => p.isUpgrade == true)
                return []
            },
        },
        created() {
            this.setOptionVisibilityVariables()
            this.isLicenseInCart()
        },
        watch: {
            'cart.cartItems'() {
                this.isLicenseInCart()
            }
        },
    }
</script>
